var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-manage" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "250px" },
              attrs: {
                placeholder: "请选择或输入门店名称搜索",
                clearable: "",
                filterable: "",
                remote: "",
                "remote-method": _vm.searchShop,
                loading: _vm.shopLoading,
              },
              on: { change: _vm.handleShopChange, clear: _vm.handleClearShop },
              model: {
                value: _vm.listQuery.storeId,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "storeId", $$v)
                },
                expression: "listQuery.storeId",
              },
            },
            _vm._l(_vm.shopList, function (item) {
              return _c("el-option", {
                key: item.storeId,
                attrs: { label: item.storeName, value: item.storeId },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "row-key": _vm.getRowKey,
            border: "",
            "tree-props": { children: "children", hasChildren: "hasChildren" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              prop: "data.id",
              width: "90",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "类型",
              prop: "data.code",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type:
                            row.data.code === "门店"
                              ? "primary"
                              : row.data.code === "单位"
                              ? "success"
                              : row.data.code === "分组"
                              ? "warning"
                              : "info",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(row.data.code) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "名称", prop: "data.name", "min-width": "160" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "限定数量",
              prop: "data.limitQuantity",
              width: "140",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.data.code === "分组"
                      ? _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ])
                      : row.data.limitQuantity === null ||
                        row.data.limitQuantity === undefined
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v("\n          不限量\n        ")]
                        )
                      : row.data.limitQuantity <= 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "danger", size: "mini" } },
                          [_vm._v("\n          已售罄 (0)\n        ")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "success", size: "mini" } },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.data.limitQuantity) +
                                " 份\n        "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "估清状态",
              prop: "data.estimateFlag",
              width: "110",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.data.code === "分组"
                      ? _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ])
                      : row.data.estimateFlag == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "danger", size: "mini" } },
                          [_vm._v("已估清")]
                        )
                      : row.data.estimateFlag == 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "mini" } },
                          [_vm._v("未估清")]
                        )
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.listQuery.page,
              "page-size": _vm.listQuery.limit,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
            },
            on: {
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "info-tip" }, [
      _c("i", { staticClass: "el-icon-info" }),
      _vm._v(
        " 限定数量由天财对接实时/异步同步；限定数量为0时系统自动估清\n    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }